import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import React from "react";
import {
  TextField,
  Box
} from "@mui/material";

export const SearchInput = React.memo(({ textValue, onChange }) => {
    return (
      <Box sx={{ px: 2, py: 1 }} component="li" onClick={(e) => e.stopPropagation()}>
        <TextField
          type="text"
          placeholder="검색"
          value={textValue} // ref 값을 보여줌
          onChange={onChange} // 실제 상태는 ref에 저장됨
          onKeyDown={(e) => e.stopPropagation()}
          size="small"
          fullWidth
          variant="standard"
          autoFocus
          onClick={(e) => e.stopPropagation()} // 클릭 버블링 차단
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              sx: {
                fontSize: '0.7rem', // 글자 크기 조정
              }
            },
          }}
        />
      </Box>
    );
  });